import { render, staticRenderFns } from "./ConsultarMarcacao.vue?vue&type=template&id=386033f5&"
import script from "./ConsultarMarcacao.vue?vue&type=script&lang=js&"
export * from "./ConsultarMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports